import { render, staticRenderFns } from "./GreenhouseGasTable.vue?vue&type=template&id=8bb71c98&scoped=true"
import script from "./GreenhouseGasTable.vue?vue&type=script&lang=js"
export * from "./GreenhouseGasTable.vue?vue&type=script&lang=js"
import style0 from "./GreenhouseGasTable.vue?vue&type=style&index=0&id=8bb71c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb71c98",
  null
  
)

export default component.exports